import { SubCollapse } from '../../../models/collapse';
import { useRefGetter, useSingleton, useUpdate } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { useCollapse } from './useCollapse';
import { useSubCollapse } from './useSubCollapse';
export function useCreateSubCollapse(options, id) {
  var root = useCollapse();
  var parent = useSubCollapse();
  var subCollapse = useSingleton(function () {
    return new SubCollapse(root, parent, id);
  });
  var update = useUpdate();
  subCollapse.updateSubCollapseOption(options);
  var prevOpenedGetter = useRefGetter(subCollapse.isOpened());
  var setOpened = useCallback(function (open) {
    subCollapse.setOpened(open);
  }, []);
  useEffect(function () {
    var change = function change() {
      if (prevOpenedGetter() !== subCollapse.isOpened()) {
        update();
      }
    };

    root.addListener('open-ids-change', change);
    return function () {
      root.removeListener('open-ids-change', change);
      subCollapse.dispose();
    };
  }, []);
  return {
    setOpened: setOpened,
    subCollapse: subCollapse,
    lazy: root.getLazy(),
    isOpen: subCollapse.isOpened()
  };
}